import type { UrlProjectName } from './types';

/*
 * Projects Metadata
 */
export const PROJECTS_METADATA_DESC = `Browse our portfolio of custom home builds and projects, showcasing quality craftsmanship and personalized design. Discover our completed projects and see what Cornerstone Homes can create for you.`;

export const PROJECTS_METADATA_TITLE = `Cornerstone Homes | Our Projects & Custom Home Builds`;

export const PROJECTS_METADATA_KEYWORDS = [
  'custom home projects Oklahoma',
  'custom home portfolio Claremore',
  'Cornerstone Homes projects',
  'modern farmhouse Oklahoma',
  'custom home builds Rogers County',
  'custom home gallery Oklahoma',
  'new home construction portfolio',
];

export const PROJECT_NAMES: UrlProjectName[] = [
  'willow',
  'river-ranch',
  'hazel',
  'sellers',
  'sparrow',
  'ling',
  'geranium',
  'inspiration',
];
